import React from 'react';
import { useLocation } from '@reach/router';

import PPQController from '../apps/ppq/PPQController';
import PPQResultController from '../apps/ppq/PPQResultController';
import Layout from '../components/layout';

const PPQTemplate = ({ data = {} }) => {
  const { partnerLogo, partnerName, referralUrl } = data.templateFields?.ppqFields;
  const location = useLocation();
  return (
    <Layout partnerLogo={partnerLogo?.sourceUrl}>
      {location?.pathname.includes('outcome') ? (
        <PPQResultController partnerName={partnerName} />
      ) : (
        <PPQController partnerName={partnerName} inviteLink={referralUrl} partnerResultURL={data.uri} />
      )}
    </Layout>
  );
};

export default PPQTemplate;
